import {memo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import arrowLeft from '../../img/icons/arrow-left.svg';

const Header = memo(() => {

    // Get the previous state here.
    const {previous_state} = useSelector((state) => state.sidebar);
    const dispatch = useDispatch();

    const closeSidebar = useCallback(() => {
        dispatch({ type : 'CLOSE_SIDEBAR' });
        }, [dispatch],
    );

    const returnToPrevious = useCallback(() => {
        if ( previous_state ) {
            dispatch({
                type : 'BACK_SIDEBAR',
                payload : {
                    mode: previous_state
                },
            })
        }
        }, [dispatch, previous_state],
    );

    return(
        <div className={`${!previous_state ? 'only-child' : ''} sidebar--header`}>
            {
                previous_state ? (
                    <button onClick={returnToPrevious} className="cursor btn first-focus back">
                        <img width="16" src={arrowLeft} alt="Left arrow icon" title="Return to previous step" />
                        Back
                    </button>
                ) : ''
            }
            <button onClick={closeSidebar} className="cursor first-focus close">Close</button>
        </div>
    )
});

export default Header;